<template>
  <SidebarBase>
    <section class="flex flex-col space-y-3 xs:pt-8 lg:pt-0">
      <h4 class="h4 text-black sidebar-title font-alt" v-text="'Search'" />
      <InputGroup :placeholder="'Lets find something ...'" :size="'small'" v-model="query" />
    </section>
    <section class="flex flex-col py-8">
      <h4 class="h4 text-black sidebar-title font-alt" v-text="'Category'" />
      <fieldset class="flex flex-col space-y-4 pt-4">
        <client-only>
          <div class="relative flex items-start" v-for="{ title, _id } in store.state.blogCategories">
            <div class="flex h-6 items-center">
              <input
                v-model="selectedBlogCategories"
                :id="_id"
                name=""
                type="checkbox"
                class="h-5 w-5 rounded border-[#D0D5DD] text-blue-600 focus:ring-blue-600"
                :value="_id"
              />
            </div>
            <div class="ml-3 text-base">
              <label :for="`#${_id}`" class="font-medium text-gray-700" v-text="title" />
            </div>
          </div>
        </client-only>
      </fieldset>
    </section>
  </SidebarBase>
</template>

<script setup lang="ts">
import { useStore } from 'vuex'

const store = useStore()
const selectedBlogCategories = ref([])

let query = ref<string>('')

watch(
  () => [selectedBlogCategories.value, query.value],
  ([categories, query]) => {
    store.commit('setSelectedBlogCategories', {
      categories,
      query,
    })
  }
)
</script>
